<template>

    <div class="form-row">
        <div class="col">
            <input type="file" class="form-control" @change="onFileChange">
        </div>
        <div class="col" v-if="handler">
            <img :src="handler">
            <span class="close" @click="removeImage">&times;</span>
        </div>
    </div>

</template>
<style scoped>

img {
    background-image: linear-gradient(0deg, #fff 50%, transparent 50%),linear-gradient(90deg, #ccc 50%, white 50%);
  background-size:2px 2px;
}

.close {
    position: absolute;;
    top: 0;
    z-index: 2;
    right: 10px;
    background: #fff;
    border-radius: 50px;
    width: 1.5rem;
    text-align: center;
    cursor: pointer;

}

</style>

<script>
import axios from 'axios';

export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'',
      }
  },
  mounted(){
      this.handler = this.value;
  },
  methods:{
      removeImage(){
          this.handler = '';
          this.change();
      },
    change(){
        this.$emit('change',this.handler);
        this.$emit('input',this.handler);
    },

    onFileChange(event,field){
        var files = event.target.files || event.dataTransfer.files;

        var file = files[0];
        if(!file) return;
        event.target.value='';

        var reader = new FileReader();
        reader.onload = (e) => {
            var base64 =  e.target.result;
            var data = {
                name:file.name,
                content:base64
            }

            axios.post('/api/upload',data).then((response)=> {
                this.handler = response.data;
                this.change();
            }).catch((error) =>  {
                console.error(error);
                if(error.response) alert(error.response.data);
            })

        }
        reader.readAsDataURL(file);
    }

  }

}
</script>
